export const availabilityValues = ['unavailable', 'available', 'conditional'] as const;
export type AvailabilityValues = (typeof availabilityValues)[number];

export type PartnerWorkerDto = {
  id: string;
  shiftClaimId?: string;
  name: string;
  hasRequiredCertificates: boolean;
  email: string;
  phone: string;
  availability: AvailabilityValues;
};

export type PartnerWorkerInfiniteQueryResponseDto = {
  totalRows: number;
  nextPage?: number;
  items: PartnerWorkerDto[];
};
